import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { PostProjektCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [PostProjektCommandService],
  exports: []
})
export class PostProjektCommandServiceModule { }
